export function buildFleetQuery(fleetId: string[], batteryType?: string[]): string {
  const query = `fleetId=${fleetId}`;
  return batteryType?.length ? `${query}&batteryType=${batteryType}` : query;
}
